import { DateTimeField, DateTimePicker } from "@mui/x-date-pickers";

import { Box, SxProps } from "@mui/material";
import dayjs from "dayjs";
import { ReactNode, Suspense } from "react";
import { useTranslation } from "react-i18next";
import FormFieldSkeleton from "components/skeletons/FormField";
import { Await } from "react-router";

export interface AuturaDateTimePickerProps {
  label?: string;
  id?: string;
  dateTime: Date | null;
  setDateTime: (date: Date | null) => void;
  readonly?: boolean;
  required?: boolean;
  initialValue?: string;
  resolve?: Promise<any>;
  variant?: "standard" | "outlined" | "filled";
  margin?: "none" | "dense" | "normal";
  helperText?: string;
  disabled?: boolean;
  disableFuture?: boolean;
  disablePast?: boolean;
  sx?: SxProps;
}

const AuturaDateTimePicker = ({
  label = "",
  id,
  dateTime,
  setDateTime,
  readonly = false,
  required = false,
  initialValue,
  variant = "outlined",
  margin = "none",
  helperText,
  resolve,
  disableFuture = false,
  disablePast = false,
  disabled = false,
  sx,
}: AuturaDateTimePickerProps): ReactNode => {
  return (
    <Suspense
      fallback={
        <FormFieldSkeleton
          id={id}
          variant={variant}
          margin={margin}
          initialValue={initialValue}
          required={required}
        />
      }
    >
      <Await resolve={resolve}>
        <DateTimePicker
          sx={sx}
          label={required ? label + " *" : label}
          value={dateTime ? dayjs(dateTime) : null}
          disableFuture={disableFuture}
          disablePast={disablePast}
          readOnly={readonly}
          slotProps={{
            textField: {
              variant: variant,
              margin: margin,
              fullWidth: true,
              placeholder: "test",
              helperText: helperText,
            },
          }}
          disabled={disabled}
          onChange={(dt) => setDateTime(dt?.toDate() || null)}
        />
      </Await>
    </Suspense>
  );
};

export default AuturaDateTimePicker;
